// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const WeddingRingLinkFragmentDoc = gql`
    fragment weddingRingLink on CatalogueWeddingRing {
  __typename
  catalogueCode
  primaryMetal {
    systemCode
  }
  suffixSlug
  slug
}
    `;